module.exports = __webpack_public_path__ + "img/consultation-doctor.c9877cb2.svg";